import { useState } from "react";

const services = [
    {
        title: "User Research & Analysis",
        description: "We conduct comprehensive user research to understand your audience's needs, preferences, and behaviors, forming a solid foundation for our designs.",
        number: "01",
        svg: (
            <svg viewBox="0 0 80 80" fill="none" className="w-full h-full">
                <circle cx="34" cy="34" r="18" stroke="url(#g1)" strokeWidth="2.5" strokeDasharray="6 3">
                    <animateTransform attributeName="transform" type="rotate" from="0 34 34" to="360 34 34" dur="8s" repeatCount="indefinite" />
                </circle>
                <circle cx="34" cy="34" r="10" stroke="url(#g1)" strokeWidth="2" opacity="0.5" />
                <circle cx="34" cy="34" r="3" fill="url(#g1)">
                    <animate attributeName="r" values="3;5;3" dur="2s" repeatCount="indefinite" />
                    <animate attributeName="opacity" values="1;0.5;1" dur="2s" repeatCount="indefinite" />
                </circle>
                <line x1="47" y1="47" x2="62" y2="62" stroke="url(#g1)" strokeWidth="3" strokeLinecap="round">
                    <animate attributeName="x2" values="62;64;62" dur="2s" repeatCount="indefinite" />
                    <animate attributeName="y2" values="62;64;62" dur="2s" repeatCount="indefinite" />
                </line>
                <circle cx="62" cy="62" r="4" fill="url(#g1)">
                    <animate attributeName="r" values="4;5.5;4" dur="2s" repeatCount="indefinite" />
                </circle>
                <defs>
                    <linearGradient id="g1" x1="0" y1="0" x2="80" y2="80" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#c084fc" /><stop offset="1" stopColor="#60a5fa" />
                    </linearGradient>
                </defs>
            </svg>
        ),
    },
    {
        title: "Wireframing & Prototyping",
        description: "Our team creates wireframes and interactive prototypes that visualize the user journey, allowing for early feedback and iterations before full development.",
        number: "02",
        svg: (
            <svg viewBox="0 0 80 80" fill="none" className="w-full h-full">
                <rect x="10" y="10" width="26" height="20" rx="3" stroke="url(#g2)" strokeWidth="2">
                    <animate attributeName="opacity" values="0.4;1;0.4" dur="2.5s" repeatCount="indefinite" />
                </rect>
                <rect x="44" y="10" width="26" height="20" rx="3" stroke="url(#g2)" strokeWidth="2">
                    <animate attributeName="opacity" values="1;0.4;1" dur="2.5s" repeatCount="indefinite" />
                </rect>
                <rect x="10" y="40" width="26" height="30" rx="3" stroke="url(#g2)" strokeWidth="2">
                    <animate attributeName="opacity" values="1;0.4;1" dur="3s" repeatCount="indefinite" />
                </rect>
                <rect x="44" y="40" width="26" height="14" rx="3" stroke="url(#g2)" strokeWidth="2">
                    <animate attributeName="opacity" values="0.4;1;0.4" dur="3s" repeatCount="indefinite" />
                </rect>
                <rect x="44" y="60" width="26" height="10" rx="3" stroke="url(#g2)" strokeWidth="2">
                    <animate attributeName="opacity" values="1;0.4;1" dur="2s" repeatCount="indefinite" />
                </rect>
                <defs>
                    <linearGradient id="g2" x1="0" y1="0" x2="80" y2="80" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#c084fc" /><stop offset="1" stopColor="#60a5fa" />
                    </linearGradient>
                </defs>
            </svg>
        ),
    },
    {
        title: "Visual Design",
        description: "We design aesthetically pleasing interfaces that not only capture attention but also reflect your brand's identity, tailored to resonate with your target audience.",
        number: "03",
        svg: (
            <svg viewBox="0 0 80 80" fill="none" className="w-full h-full">
                <circle cx="26" cy="26" r="10" fill="#a855f7" opacity="0.75">
                    <animate attributeName="r" values="10;12;10" dur="3s" repeatCount="indefinite" />
                </circle>
                <circle cx="54" cy="26" r="10" fill="#3b82f6" opacity="0.65">
                    <animate attributeName="r" values="10;12;10" dur="3s" begin="0.5s" repeatCount="indefinite" />
                </circle>
                <circle cx="40" cy="50" r="10" fill="#06b6d4" opacity="0.65">
                    <animate attributeName="r" values="10;12;10" dur="3s" begin="1s" repeatCount="indefinite" />
                </circle>
                <circle cx="40" cy="35" r="8" fill="white" opacity="0.06" />
                <path d="M20 68 Q40 58 60 68" stroke="url(#g3)" strokeWidth="1.5" strokeDasharray="3 2" opacity="0.5">
                    <animate attributeName="strokeDashoffset" values="0;20" dur="2s" repeatCount="indefinite" />
                </path>
                <defs>
                    <linearGradient id="g3" x1="0" y1="0" x2="80" y2="80" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#c084fc" /><stop offset="1" stopColor="#60a5fa" />
                    </linearGradient>
                </defs>
            </svg>
        ),
    },
    {
        title: "Usability Testing",
        description: "We conduct usability tests to gather insights on user interactions, ensuring that our designs are intuitive and effective before launch.",
        number: "04",
        svg: (
            <svg viewBox="0 0 80 80" fill="none" className="w-full h-full">
                <path d="M20 15 L20 52 L30 42 L36 58 L42 55 L36 39 L48 39 Z" fill="url(#g4)" opacity="0.85">
                    <animateTransform attributeName="transform" type="translate" values="0,0; 6,4; 0,0" dur="2.5s" repeatCount="indefinite" />
                </path>
                <circle cx="52" cy="52" r="6" stroke="url(#g4)" strokeWidth="1.5" opacity="0">
                    <animate attributeName="r" values="6;16" dur="1.5s" repeatCount="indefinite" begin="0.5s" />
                    <animate attributeName="opacity" values="0.8;0" dur="1.5s" repeatCount="indefinite" begin="0.5s" />
                </circle>
                <circle cx="52" cy="52" r="6" stroke="url(#g4)" strokeWidth="1.5" opacity="0">
                    <animate attributeName="r" values="6;22" dur="1.5s" repeatCount="indefinite" begin="0.9s" />
                    <animate attributeName="opacity" values="0.5;0" dur="1.5s" repeatCount="indefinite" begin="0.9s" />
                </circle>
                <path d="M58 18 L63 24 L74 12" stroke="#4ade80" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="20" strokeDashoffset="20">
                    <animate attributeName="strokeDashoffset" values="20;0" dur="0.6s" fill="freeze" begin="0.3s" />
                </path>
                <defs>
                    <linearGradient id="g4" x1="0" y1="0" x2="80" y2="80" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#c084fc" /><stop offset="1" stopColor="#60a5fa" />
                    </linearGradient>
                </defs>
            </svg>
        ),
    },
    {
        title: "Responsive Design",
        description: "Our designs are optimized for all devices, ensuring a seamless user experience whether on mobile, tablet, or desktop.",
        number: "05",
        svg: (
            <svg viewBox="0 0 80 80" fill="none" className="w-full h-full">
                <rect x="8" y="14" width="40" height="28" rx="3" stroke="url(#g5)" strokeWidth="2">
                    <animate attributeName="opacity" values="1;0.5;1" dur="3s" repeatCount="indefinite" />
                </rect>
                <line x1="28" y1="42" x2="28" y2="50" stroke="url(#g5)" strokeWidth="2" />
                <line x1="20" y1="50" x2="36" y2="50" stroke="url(#g5)" strokeWidth="2" strokeLinecap="round" />
                <rect x="52" y="20" width="18" height="26" rx="2.5" stroke="url(#g5)" strokeWidth="2">
                    <animate attributeName="opacity" values="0.5;1;0.5" dur="3s" repeatCount="indefinite" />
                </rect>
                <circle cx="61" cy="43" r="1.5" fill="url(#g5)" />
                <rect x="57" y="52" width="12" height="20" rx="2" stroke="url(#g5)" strokeWidth="1.8">
                    <animate attributeName="opacity" values="1;0.5;1" dur="2.5s" begin="0.5s" repeatCount="indefinite" />
                </rect>
                <circle cx="63" cy="69" r="1.2" fill="url(#g5)" />
                <defs>
                    <linearGradient id="g5" x1="0" y1="0" x2="80" y2="80" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#c084fc" /><stop offset="1" stopColor="#60a5fa" />
                    </linearGradient>
                </defs>
            </svg>
        ),
    },
    {
        title: "Ongoing Support & Iteration",
        description: "Post-launch, we offer ongoing support and design iterations based on user feedback and performance analytics, ensuring your product evolves with user needs.",
        number: "06",
        svg: (
            <svg viewBox="0 0 80 80" fill="none" className="w-full h-full">
                <path d="M40 12 A28 28 0 1 1 12 40" stroke="url(#g6)" strokeWidth="2.5" strokeLinecap="round">
                    <animateTransform attributeName="transform" type="rotate" from="0 40 40" to="360 40 40" dur="4s" repeatCount="indefinite" />
                </path>
                <path d="M12 40 L8 30 M12 40 L22 36" stroke="url(#g6)" strokeWidth="2.5" strokeLinecap="round">
                    <animateTransform attributeName="transform" type="rotate" from="0 40 40" to="360 40 40" dur="4s" repeatCount="indefinite" />
                </path>
                <circle cx="40" cy="40" r="8" fill="url(#g6)" opacity="0.15">
                    <animate attributeName="r" values="8;12;8" dur="2s" repeatCount="indefinite" />
                </circle>
                <circle cx="40" cy="40" r="4" fill="url(#g6)">
                    <animate attributeName="opacity" values="1;0.5;1" dur="2s" repeatCount="indefinite" />
                </circle>
                <defs>
                    <linearGradient id="g6" x1="0" y1="0" x2="80" y2="80" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#c084fc" /><stop offset="1" stopColor="#60a5fa" />
                    </linearGradient>
                </defs>
            </svg>
        ),
    },
];

export default function UIUXServices() {
    const [active, setActive] = useState(0);
    const [animating, setAnimating] = useState(false);
    const [displayIndex, setDisplayIndex] = useState(0);

    const switchTo = (i: number) => {
        if (i === active || animating) return;
        setAnimating(true);
        setTimeout(() => {
            setDisplayIndex(i);
            setActive(i);
            setAnimating(false);
        }, 280);
    };

    const activeItem = services[displayIndex];

    return (
        <section className="relative py-16 md:py-24 overflow-hidden">
            <style>{`
                @keyframes panelIn {
                    from { opacity: 0; transform: translateY(20px) scale(0.98); }
                    to   { opacity: 1; transform: translateY(0) scale(1); }
                }
                @keyframes panelOut {
                    from { opacity: 1; transform: translateY(0) scale(1); }
                    to   { opacity: 0; transform: translateY(-16px) scale(0.98); }
                }
                .panel-in  { animation: panelIn  0.35s cubic-bezier(0.4,0,0.2,1) forwards; }
                .panel-out { animation: panelOut 0.28s cubic-bezier(0.4,0,0.2,1) forwards; }

                .tab-pill { position: relative; transition: color 0.2s; }
                .tab-pill::after {
                    content: '';
                    position: absolute;
                    bottom: -2px; left: 50%;
                    transform: translateX(-50%) scaleX(0);
                    width: 80%; height: 2px;
                    border-radius: 9999px;
                    background: linear-gradient(90deg, #9333ea, #3b82f6);
                    transition: transform 0.3s cubic-bezier(0.4,0,0.2,1);
                }
                .tab-pill.tab-active::after { transform: translateX(-50%) scaleX(1); }

                /* Hide scrollbar completely */
                .tabs-scroll { 
                    overflow-x: auto;
                    -ms-overflow-style: none;
                    scrollbar-width: none;
                }
                .tabs-scroll::-webkit-scrollbar { display: none; }
            `}</style>

            <div className="container">

                {/* Header */}
                <div className="text-center mb-12">
                    <h2 className="text-3xl md:text-[2.6rem] font-bold text-white leading-snug mb-4">
                        Our UI/UX Design Services
                        {/* <span className="bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-400 bg-clip-text text-transparent pl-2"> */}
                        {/* </span> */}
                    </h2>
                    {/* <div className="w-12 h-0.5 rounded-full bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-400 mx-auto" /> */}
                </div>

                {/* Tab bar — scrollbar hidden */}
                <div
                    className="tabs-scroll flex items-center gap-1 pb-3 mb-10"
                    style={{ borderBottom: "1px solid rgba(255,255,255,0.07)" }}
                >
                    {services.map((item, i) => (
                        <button
                            key={item.title}
                            onClick={() => switchTo(i)}
                            className={`tab-pill flex items-center gap-2 px-4 py-2.5 font-semibold whitespace-nowrap shrink-0 transition-colors duration-200 ${active === i ? "tab-active" : ""}`}
                            style={{ color: active === i ? "white" : "rgba(255,255,255,0.35)" }}
                        >
                            {/* <span
                                className="text-xs font-bold tabular-nums"
                                style={{ color: active === i ? "rgba(192,132,252,0.9)" : "rgba(255,255,255,0.2)" }}
                            >
                                {item.number}
                            </span> */}
                            {item.title}
                        </button>
                    ))}
                </div>

                {/* Detail panel */}
                <div
                    className={`grid md:grid-cols-2 gap-8 rounded-2xl p-8 md:p-12 border ${animating ? "panel-out" : "panel-in"}`}
                    style={{
                        background: "linear-gradient(135deg, rgba(147,51,234,0.09) 0%, rgba(37,99,235,0.09) 100%)",
                        borderColor: "rgba(147,51,234,0.22)",
                        boxShadow: "0 0 60px rgba(147,51,234,0.07)",
                    }}
                >
                    {/* Left */}
                    <div className="flex flex-col justify-center space-y-6">
                        <p
                            className="text-7xl font-black leading-none select-none"
                            style={{
                                background: "linear-gradient(135deg, rgba(147,51,234,0.3), rgba(59,130,246,0.3))",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                            }}
                        >
                            {activeItem.number}
                        </p>
                        <div>
                            <h3 className="text-white font-bold text-2xl md:text-3xl mb-3">{activeItem.title}</h3>
                            <div className="w-12 h-0.5 rounded-full bg-gradient-to-r from-purple-500 to-blue-500 mb-4" />
                            <p className="text-base md:text-lg leading-relaxed" style={{ color: "rgba(255,255,255,0.5)" }}>
                                {activeItem.description}
                            </p>
                        </div>

                        {/* Prev / Next */}
                        <div className="flex items-center gap-3 pt-2">
                            <button
                                onClick={() => switchTo((active - 1 + services.length) % services.length)}
                                className="w-10 h-10 rounded-xl border flex items-center justify-center transition-all duration-200 hover:border-purple-500/50 hover:bg-purple-500/10"
                                style={{ borderColor: "rgba(255,255,255,0.1)" }}
                            >
                                <svg className="w-4 h-4 text-white/60" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
                                </svg>
                            </button>
                            <button
                                onClick={() => switchTo((active + 1) % services.length)}
                                className="w-10 h-10 rounded-xl border flex items-center justify-center transition-all duration-200 hover:border-purple-500/50 hover:bg-purple-500/10"
                                style={{ borderColor: "rgba(255,255,255,0.1)" }}
                            >
                                <svg className="w-4 h-4 text-white/60" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                                </svg>
                            </button>
                            <span className="text-sm ml-1" style={{ color: "rgba(255,255,255,0.25)" }}>
                                <span style={{ color: "rgba(192,132,252,0.8)" }}>{String(active + 1).padStart(2, "0")}</span>
                                {" / "}{String(services.length).padStart(2, "0")}
                            </span>
                        </div>
                    </div>

                    {/* Right — bigger animated SVG */}
                    <div className="flex items-center justify-center">
                        <div className="relative flex items-center justify-center">
                            <div
                                className="absolute w-64 h-64 rounded-full"
                                style={{ background: "radial-gradient(circle, rgba(147,51,234,0.14) 0%, transparent 70%)" }}
                            />
                            <div
                                className="absolute w-52 h-52 rounded-full border"
                                style={{ borderColor: "rgba(147,51,234,0.1)" }}
                            />
                            <div
                                className="absolute w-36 h-36 rounded-full border"
                                style={{ borderColor: "rgba(59,130,246,0.12)" }}
                            />
                            {/* Bigger icon box — increased from w-20 h-20 to w-28 h-28 */}
                            <div
                                className="relative z-10 w-28 h-28 rounded-2xl flex items-center justify-center p-4"
                                style={{
                                    background: "linear-gradient(135deg, rgba(88,28,135,0.6), rgba(30,58,138,0.6))",
                                    boxShadow: "0 8px 40px rgba(147,51,234,0.5), 0 0 80px rgba(147,51,234,0.18)",
                                    border: "1px solid rgba(147,51,234,0.35)",
                                }}
                            >
                                {activeItem.svg}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Dot nav */}
                <div className="flex justify-center gap-2 mt-6">
                    {services.map((_, i) => (
                        <button
                            key={i}
                            onClick={() => switchTo(i)}
                            className="h-1.5 rounded-full transition-all duration-300"
                            style={{
                                width: active === i ? "2rem" : "0.375rem",
                                background: active === i
                                    ? "linear-gradient(90deg, #9333ea, #3b82f6)"
                                    : "rgba(255,255,255,0.15)",
                            }}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
}